import React from 'react';
import { cn } from 'utils/cn';

export const NavBadge = ({ children, variant = 'primary', className }) => {
    if (!children && children !== 0) return null;

    const variantStyles = {
        primary: 'bg-primary text-primary-foreground font-semibold',
        secondary: 'bg-secondary text-secondary-foreground font-medium',
        destructive: 'bg-destructive text-destructive-foreground font-semibold',
        accent: 'bg-sky-500 text-white font-semibold',
        subtle: 'bg-slate-100 text-slate-700 font-medium',
    };

    return (
        <span
            className={cn(
                'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 text-[11px] leading-none rounded-full transition-transform scale-100 animate-in fade-in zoom-in-75 duration-200',
                variantStyles[variant] || variantStyles.primary,
                className
            )}
        >
            {children}
        </span>
    );
};
